import { render, staticRenderFns } from "./aboutxh.vue?vue&type=template&id=8c90893c&scoped=true"
import script from "./aboutxh.vue?vue&type=script&lang=js"
export * from "./aboutxh.vue?vue&type=script&lang=js"
import style0 from "./aboutxh.vue?vue&type=style&index=0&id=8c90893c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c90893c",
  null
  
)

export default component.exports